<section class="scr-page scr-page--compact container-prod">
  <div class="scr-master-detail">
    <div class="head-list scr-card scr-card--padded">
      <tp-page-header
        variant="toolbar"
        class="tp-page-header--flat tp-page-header--stacked"
        title="Artículos SAP"
        [subtitle]="(articlesList | filterByProductName : searchText).length + ((articlesList | filterByProductName : searchText).length === 1 ? ' artículo' : ' artículos')"
      >
        <div class="scr-search">
          <mat-icon class="scr-search__icon" aria-hidden="true">search</mat-icon>
          <input
            type="text"
            class="form-control"
            placeholder="Buscar artículo"
            [(ngModel)]="searchText"
            />
        </div>
        <button mat-stroked-button actions class="scr-btn-secondary" type="button" (click)="cleanForm()" aria-label="Limpiar formulario">
          <mat-icon>clear_all</mat-icon>
          Limpiar formulario
        </button>
      </tp-page-header>

        <div class="list">
          <div class="row productsListTitle text-left">
            <b>Artículos</b>
          </div>
          @let filteredArticles = articlesList | filterByProductName : searchText;
          <ul class="scrollable-content">
            @for (art of filteredArticles; track art) {
              <li
                class="scr-list-item"
                [class.inactive]="art.isActive == false"
                [class.scr-list-item--selected]="isSelectedArticle(art)"
                [attr.aria-current]="isSelectedArticle(art) ? 'true' : null"
                >
                <div class="elem-row">
                  <div class="col-7 description article-name" style="cursor: pointer">
                    <a
                      (click)="editArticle(art)"
                      (keydown)="onRowKeydown($event, art)"
                      tabindex="0"
                      >{{ art.name }}</a
                      >
                    </div>
                    <div class="col-4 description d-grid justify-content-end article-code">
                      <span>{{ art.internalCode }}</span>
                    </div>
                    <div class="col-1 description d-grid justify-content-end article-action">
                      @if (art.isActive == true) {
                        <button type="button"
                          class="invisible-button"
                          (click)="deleteArticle(art)"
                          aria-label="Desactivar artículo"
                          >
                          <mat-icon
                            title="Desactivar artículo"
                            class="align-self-center"
                            style="cursor: pointer; color: grey"
                            >delete_outlined
                          </mat-icon>
                        </button>
                      }
                      @if (art.isActive == false) {
                        <button type="button"
                          class="invisible-button"
                          (click)="deleteArticle(art)"
                          aria-label="Activar artículo"
                          >
                          <mat-icon
                            title="Activar artículo"
                            class="align-self-center"
                            style="cursor: pointer; color: grey"
                            >delete
                          </mat-icon>
                        </button>
                      }
                    </div>
                  </div>
                </li>
              }
            </ul>
            @if (searchText && filteredArticles.length === 0) {
              <tp-empty-state
                icon="search_off"
                title="Sin resultados"
                message="No hay artículos que coincidan con la búsqueda."
              ></tp-empty-state>
            }
          </div>
        </div>

        <div class="form-container scr-card scr-card--padded">
          <div class="scr-detail-head">
            @if (hasSelectedArticle()) {
              <h2 class="scr-section-title">Editando: {{ articleForm.controls.name.value }}</h2>
              <p class="scr-detail-head__sub">{{ articleForm.controls.internalCode.value }}</p>
            } @else {
              <h2 class="scr-section-title">Elegí un artículo de la lista</h2>
            }
          </div>
          <form [formGroup]="articleForm" class="product sa-form" (ngSubmit)="onSubmit()">
            <div class="cf-grid">
              <div class="cf-field cf-field--full">
                <label class="cf-label" for="sa-name">Nombre *</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input id="sa-name" matInput placeholder="Nombre" name="name" formControlName="name" required />
                </mat-form-field>
              </div>
              <div class="cf-field">
                <label class="cf-label" for="sa-alias">Alias *</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input id="sa-alias" matInput placeholder="Alias" name="alias" formControlName="alias" maxlength="30" required />
                </mat-form-field>
              </div>
              <div class="cf-field">
                <label class="cf-label" for="sa-code">Código interno *</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input
                    id="sa-code"
                    matInput
                    placeholder="Código interno"
                    name="internalCode"
                    formControlName="internalCode"
                    required
                    readonly
                  />
                </mat-form-field>
              </div>
              <div class="cf-field">
                <label class="cf-label" for="sa-type">Tipo *</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select id="sa-type" formControlName="type" required placeholder="Elegí un tipo">
                    @for (type of sapTypes; track type) {
                      <mat-option [value]="type.id">
                        {{ type.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="cf-field">
                <label class="cf-label" for="sa-units">Unidades de medida *</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select id="sa-units" formControlName="measurementUnitId" required placeholder="Elegí una unidad">
                    @for (units of measureUnits; track units) {
                      <mat-option [value]="units.id">
                        {{ units.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="cf-field">
                <label class="cf-label" for="sa-area">Área *</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select id="sa-area" formControlName="assemblyAreaId" required placeholder="Elegí un área">
                    @for (assemblyArea of assemblyAreas | async; track assemblyArea) {
                      <mat-option [value]="assemblyArea.id">
                        {{ assemblyArea.name }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="cf-field">
                <label class="cf-label" for="sa-category">Categoría *</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <mat-select id="sa-category" formControlName="itemCategoryId" required placeholder="Elegí una categoría">
                    @for (itemCategory of itemCategories | async; track itemCategory) {
                      <mat-option [value]="itemCategory.id">
                        {{ itemCategory.displayName }} ({{ itemCategory.name }})
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="cf-field cf-field--full">
                <span class="cf-label">Opciones</span>
                <div class="cf-toggles">
                  <mat-slide-toggle formControlName="isCumulative">Acumulable</mat-slide-toggle>
                  <mat-slide-toggle formControlName="isVisible">Visible</mat-slide-toggle>
                  <mat-slide-toggle formControlName="isVisibleInDeliveryNote">Visible en reporte</mat-slide-toggle>
                </div>
              </div>
              <div class="cf-field cf-field--full">
                <label class="cf-label" for="sa-product">Producto</label>
                <mat-form-field appearance="outline" subscriptSizing="dynamic">
                  <input
                    id="sa-product"
                    type="text"
                    placeholder="Buscá un producto"
                    matInput
                    formControlName="productId"
                    [matAutocomplete]="auto"
                    [value]="productName"
                  />
                  <mat-autocomplete #auto="matAutocomplete">
                    @for (prod of products | async; track prod) {
                      <mat-option (click)="setShowColors()" [value]="prod.id" (keydown)="keyDownSelect($event)">
                        {{ prod.name }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>
              @if (showColors) {
                <div class="cf-field cf-field--full">
                  <label class="cf-label" for="sa-color">Color</label>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-select id="sa-color" formControlName="productColors" placeholder="Elegí un color">
                      @for (color of colorList; track color) {
                        <mat-option [value]="color.id">
                          {{ color.color }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              }
            </div>

            <div class="sa-section">
              <mat-checkbox [checked]="hasSubitems" (change)="showSubItems()">
                <span class="cf-section-title">Items asociados</span>
              </mat-checkbox>
            </div>
            @if (hasSubitems) {
              <div class="cf-grid" [formGroup]="subItemForm">
                <div class="cf-field">
                  <label class="cf-label" for="sa-son-name">Nombre</label>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input id="sa-son-name" matInput placeholder="Nombre" name="sonName" formControlName="sonName" />
                  </mat-form-field>
                </div>
                <div class="cf-field">
                  <label class="cf-label" for="sa-son-alias">Alias</label>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <input id="sa-son-alias" matInput placeholder="Alias" name="sonAlias" formControlName="sonAlias" maxlength="30" />
                  </mat-form-field>
                </div>
                <div class="cf-field cf-field--full">
                  <span class="cf-label">Opciones</span>
                  <div class="cf-toggles">
                    <mat-slide-toggle formControlName="isCumulativeSon">Acumulable</mat-slide-toggle>
                    <mat-slide-toggle formControlName="isVisibleSon">Visible</mat-slide-toggle>
                    <mat-slide-toggle formControlName="isVisibleInDeliveryNoteSon">Visible en reporte</mat-slide-toggle>
                  </div>
                </div>
                <div class="cf-field">
                  <label class="cf-label" for="sa-son-area">Área encargada</label>
                  <mat-form-field appearance="outline" subscriptSizing="dynamic">
                    <mat-select id="sa-son-area" formControlName="selectedChildAssemblyArea" placeholder="Elegí un área">
                      @for (area of childAssemblyAreas | async; track area) {
                        <mat-option [value]="area">
                          {{ area.name }}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                <div class="cf-field">
                  <label class="cf-label" for="sa-son-category">Categoría</label>
                  <div class="sa-add-row">
                    <mat-form-field appearance="outline" subscriptSizing="dynamic">
                      <mat-select id="sa-son-category" formControlName="selectedChildItemCategory" placeholder="Elegí una categoría">
                        @for (category of childItemCategories | async; track category) {
                          <mat-option [value]="category">
                            {{ category.displayName }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                    <button type="button" mat-stroked-button (click)="addSelectedItem()">
                      <mat-icon>add</mat-icon>
                      Agregar
                    </button>
                  </div>
                </div>
              </div>
            }
            @if (subItem.length > 0) {
              <div class="sa-subitems">
                <h3 class="cf-section-title">Tareas aplicadas</h3>
                <div class="tp-table-responsive">
                  <table class="table table-bordered w-100">
                    <thead>
                      <tr>
                        <th scope="col">Nombre</th>
                        <th scope="col">Alias</th>
                        <th scope="col">Área</th>
                        <th scope="col">Categoría</th>
                        <th scope="col">Visible</th>
                        <th scope="col">Acumulable</th>
                        <th scope="col">Reporte visible</th>
                        <th scope="col"><span class="visually-hidden">Quitar</span></th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (item of subItem; track item; let i = $index) {
                        <tr>
                          <td>{{ item.name }}</td>
                          <td>{{ item.alias }}</td>
                          <td>{{ item.assemblyAreaName }}</td>
                          <td>{{ item.itemCategoryName }}</td>
                          <td>
                            <mat-slide-toggle [checked]="item.isVisible" disabled="true"></mat-slide-toggle>
                          </td>
                          <td>
                            <mat-slide-toggle [checked]="item.isCumulative" disabled="true"></mat-slide-toggle>
                          </td>
                          <td>
                            <mat-slide-toggle [checked]="item.isVisibleInDeliveryNote" disabled="true"></mat-slide-toggle>
                          </td>
                          <td>
                            <button type="button" mat-icon-button title="Quitar" aria-label="Quitar" (click)="removeSelectedItem(item)">
                              <mat-icon>delete_outline</mat-icon>
                            </button>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }

            <div class="cf-actions sa-actions">
              @if (!hasSelectedArticle()) {
                <span class="no-selection-hint" role="status">Elegí un artículo de la lista para editarlo.</span>
              }
              <button mat-flat-button id="guardar" type="button" [disabled]="!hasSelectedArticle()" (click)="onSubmit()">
                Actualizar artículo
              </button>
            </div>
          </form>
                    </div>
                  </div>
</section>
